import React from 'react';
import TestimonialContainer from './testimonial.styles';
const Testimonial = ({ imageUrl, text, jop }) => {
    return (
        <TestimonialContainer>
            <img src={`${imageUrl}`} alt="img" />
            <div className="text">
                {text}
                <p>{jop}</p>
            </div>
        </TestimonialContainer>
    );
};
export default Testimonial;
